import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import Theme from 'pf9-ui-components/built/theme-manager/themes/model'
import React, { useMemo } from 'react'
import colors from 'core/themes/base/colors'
export enum IconStatus {
  InProgress = 'inProgress',
  Success = 'success',
  Failed = 'failed',
  NotStarted = 'notStarted',
  Warning = 'warning',
}
export interface SubStep {
  stepId: string
  status: string
  name: string
  error?: Error
  warning?: Error
}

export interface StepDetails {
  stepId: string
  status: string
  title: string
  subSteps: SubStep[]
}
interface StepBarFillerProps {
  step: any
  isFirst: boolean
  isLast: boolean
}

const colorMap = {
  [IconStatus.Success]: colors.green[80],
  [IconStatus.InProgress]: colors.blue[400],
  [IconStatus.Failed]: colors.red[80],
  [IconStatus.Warning]: colors.yellow[500],
}

const useStyles = makeStyles<Theme>((theme) => ({
  stepBar: {
    height: '6px',
    width: '100%',
    borderRadius: '3px 3px 0px 0px',
  },
  stepBarFirst: {
    borderRadius: '0px 3px 0px 3px',
  },
  stepBarLast: {
    borderRadius: '3px 0px 3px 0px',
  },
  stepBarSuccess: {
    background: colorMap[IconStatus.Success],
  },
  stepBarInProgress: {
    background: colorMap[IconStatus.InProgress],
  },
  stepBarFailed: {
    background: colorMap[IconStatus.Failed],
  },
  stepBarWarning: {
    background: colorMap[IconStatus.Warning],
  },
}))

const StepBarFiller = ({ step, isFirst, isLast }: StepBarFillerProps) => {
  const calculatePercent = (currentVal, TotalVal) => (currentVal / TotalVal) * 100
  const stepProgress = useMemo(() => {
    const totalSteps = step?.subSteps?.length
    const completedSteps = step?.subSteps?.filter(
      (step) => step?.status === IconStatus.InProgress || step?.status === IconStatus.Success,
    )?.length
    const fillComplete = 100
    return step?.status === IconStatus.Failed || step?.status === IconStatus.Warning
      ? fillComplete
      : calculatePercent(completedSteps, totalSteps)
  }, [step?.subSteps, step?.status])

  const classes = useStyles()

  return (
    <div
      className={clsx(classes.stepBar, {
        [classes.stepBarFirst]: isFirst,
        [classes.stepBarLast]: isLast,
        [classes.stepBarSuccess]: step?.status === IconStatus.Success,
        [classes.stepBarInProgress]: step?.status === IconStatus.InProgress,
        [classes.stepBarFailed]: step?.status === IconStatus.Failed,
        [classes.stepBarWarning]: step?.status === IconStatus.Warning,
      })}
    />
  )
}

export default StepBarFiller
